"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentCurrency = exports.DEFAULT_CURRENCY = void 0;
var react_1 = require("react");
var balance_1 = require("../balance");
var countries_1 = require("../countries");
var geo_1 = require("../geo");
var useConfig_1 = require("../useConfig");
exports.DEFAULT_CURRENCY = 'EUR';
var CONFIG_CURRENCY = process.env.NEXT_PUBLIC_DEFAULT_CURRENCY;
var useCurrentCurrency = function () {
    var _a;
    var data = (0, balance_1.useBalance)().data;
    var countriesData = (0, countries_1.useCountries)().data;
    var geoData = (0, geo_1.useGeo)().data;
    var config = (0, useConfig_1.useConfig)();
    return (0, react_1.useMemo)(function () {
        var _a;
        var currentCountry = countriesData === null || countriesData === void 0 ? void 0 : countriesData.find(function (country) { var _a; return country.code === ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode); });
        return ((data === null || data === void 0 ? void 0 : data.currency) ||
            ((_a = config === null || config === void 0 ? void 0 : config.currencies) === null || _a === void 0 ? void 0 : _a['default']) ||
            (currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.currencyCode) ||
            CONFIG_CURRENCY ||
            exports.DEFAULT_CURRENCY);
    }, [
        data === null || data === void 0 ? void 0 : data.currency,
        (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode,
        countriesData,
        config === null || config === void 0 ? void 0 : config.currencies,
    ]);
};
exports.useCurrentCurrency = useCurrentCurrency;
